import React, { Component } from 'react';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import ViewFinderIcon from '@mui/icons-material/GpsFixed';
import $ from 'jquery';
import { getMarkers } from '../helpers/helper'

const viewFinderStyle = {
    position: "fixed",
    /*top: "calc(50% - 12px + 32px)",*/
    top: "calc(50% - 12px)",
    left: "calc(50% - 12px)"
}

// https://snazzymaps.com/editor per stilizzare la mappa
const __GMAP_STYLE = [
    {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    }
];

class Map extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bounds: null,
            defaultPosition: {
                lat: null,
                lng: null,
                zoom: null
            },
            myPosition: {
                lat: 0,
                lng: 0
            },
            currentPosition: {
                lat: 0,
                lng: 0,
                zoom: 13
            },
            currentCenter: {
                lat: null,
                lng: null
            },
            viewFinder: {
                top: 0
            },
            markers: [
            ],
            lightPoints: [],
            cabinets: []
        };

        this.currentCenter = {
            lat: null,
            lng: null
        }

        this.map = null;

        // Bind
        this.renderLightPoint = this.renderLightPoint.bind(this);
        this.renderCabinet = this.renderCabinet.bind(this);
        this.refreshPosition = this.refreshPosition.bind(this);
        this.handleMapMounted = this.handleMapMounted.bind(this);
        this.getAndSetBounds = this.getAndSetBounds.bind(this)

        // Marker style
        this.iconLightPoint = {
            path: 'M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z',
            fillColor: '#2196f3',
            fillOpacity: 1,
            scale: 0.05,
            strokeWeight: 1,
            strokeColor: '#ffffff',
            anchor: new window.google.maps.Point(192, 512),
            labelOrigin: new window.google.maps.Point(192, 192)
        }
        this.iconLabelLightPoint = {
            fontFamily: 'Fontawesome',
            fontSize: '10px',
            text: '\uf0eb',
            color: 'white',
        }
        this.iconCabinet = {
            path: 'M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z',
            fillColor: '#ff9800',
            fillOpacity: 1,
            scale: 0.05,
            strokeWeight: 1,
            strokeColor: '#ffffff',
            anchor: new window.google.maps.Point(192, 512),
            labelOrigin: new window.google.maps.Point(192, 192)
        }
        this.iconLabelCabinet = {
            fontFamily: 'Fontawesome',
            fontSize: '10px',
            text: '\uf0e8',
            color: 'white',
        }
    }

    componentDidMount() {
        // Calcolo altezza mirino
        this.setState({ 'viewFinder': { 'top': ($("#root").height() - 56) / 2 } });
        this.setState({ 'currentCenter': this.props.mapCenter });
    }

    handleMapMounted(map) {
        // recupera il metodo del padre se esiste
        const { handleMapMounted } = this.props;
        // Se map è valorizzato allora imposta il riferimento all'oggetto di googleMaps
        this.map = map;
        
        if (map && this.props.onMapReady) {
            this.props.onMapReady(this);
            handleMapMounted(map);
        }
        
        this.getAndSetBounds();
    }

    handleClickOpen() {
        // NOTHING
    }

    /**
     * Funzione di aggiunta marker
     * @param {*} coords
     */
    addMarker = (coords) => {
        /*const marker = <Marker position={{lat: coords.lat, lng: coords.lng}} />;
        let tmpMarkers = this.state.markers;
        tmpMarkers.push(marker);
        this.setState({'markers': tmpMarkers});*/
    }

    // Funzione per il ricalcolo del centro
    /**
     * Funzione di aggiornamento stato centro corrente della mappa
     * L'oggetto currentPosition viene utilizzato per avere le coordinate da utilizzare per l'inserimento oggetti
     * @param {*} map
     */
    refreshPosition = () => {
        //this.setState({ 'currentCenter': { 'lat': map.lat(), 'lng': map.lng() } });
    }

    /**
     * Procedura di aggiornamento della propria posizione
     * Imposta sempre il centro della mappa visualizzata con la propria posizione
     */
    handleMyPosition = () => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.setState({
                        'myPosition': { 'lat': position.coords.latitude, 'lng': position.coords.longitude },
                        "defaultPosition": this.state.myPosition,
                        "currentPosition": this.state.myPosition
                    });
                },
                function (err) {
                    console.error(err);
                }
            );
        } else {
            console.warn("warning", "Map.js", "handleMyPosition", "GEOLOCATION_ERROR");
        }
    }

    /**
     * Ricezione della proprietà sul centro mappa dal componente padre MainLayout
     * Quando si seglie un nuovo progetto, il centro mappa viene modificato
     * la proprietà passata comprende lat,lng,zoom
     * @param {*} props
     */
/*    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.state.lightPoints) !== JSON.stringify(nextProps.lightPoints)) {
            this.renderLightPoint(nextProps.lightPoints);
        }

        if (JSON.stringify(this.state.cabinets) !== JSON.stringify(nextProps.cabinets)) {
            this.renderCabinet(nextProps.cabinets);
        }

        if (JSON.stringify(this.state.currentPosition) !== JSON.stringify(nextProps.mapCenter)) {
            this.setState({ "currentPosition": nextProps.mapCenter });
        }
    }*/

    async getAndSetBounds() {

        function boundsToArray(bounds) {    //Funzione per fare la conversione di bounds > array nel format correto richiesto da getMarkers
            if(!bounds){
                return 
            } else {
                return [
                    [bounds.getSouthWest().lng(), bounds.getSouthWest().lat()],
                    [bounds.getNorthEast().lng(), bounds.getNorthEast().lat()]
                ];
            }
        }

        if (this.map) {
            const bounds = this.map.getBounds();

            if (bounds) {
                this.setState({ bounds: bounds });
                
                const bbox = boundsToArray(bounds)
                const projectUuid = localStorage.getItem("currentProjectId")

                if(bbox){
                    const markerList = await getMarkers(bbox, projectUuid) 
                        .then((res) => {
                            return (res && res.data.rows) ? res.data.rows : [];
                        })
                        .catch((err) => {
                            console.error(err)
                            return []
                        })

                    if(markerList.length >= 0){
                        // Filtra i LP e CB
                        const lightpointsArr = markerList.filter(item => item.type === 'lightpoint');
                        const cabinetsArr = markerList.filter(item => item.type === 'cabinet');

                        // Aggiunge la prop "geometry" a gli LP 
                        lightpointsArr.forEach(lp => {
                            lp.geometry = lp.position;
                        });

                        // Aggiunge la prop "geometry" a gli CB 
                        cabinetsArr.forEach(cp => {
                            cp.geometry = cp.position;
                        });

                        this.renderLightPoint(lightpointsArr);
                        this.renderCabinet(cabinetsArr);
                    }
                }

            } else {
                console.log("Bounds non disponibili al momento.");
            }

        } else {
            console.log("Map non disponibile.");
        }
    }

    

    renderLightPoint(lightPointsArr) {
        let plComponents = lightPointsArr.map((lp,index) => {
            if (!(lp && lp.geometry && lp.geometry[0] && lp.geometry[1])) {
                return null;
            }

            return (
                <Marker
                    key={lp.id}
                    position={{ lng: lp.geometry[0], lat: lp.geometry[1] }}
                    label={this.iconLabelLightPoint}
                    icon={this.iconLightPoint}
                />
            );
        }).filter(x => x );
    this.setState({ 'lightPoints': plComponents })
    }

    renderCabinet(cabinetsArr) {
        let plComponents = cabinetsArr.map((cp,index) => {
            if (!(cp && cp.geometry && cp.geometry[0] && cp.geometry[1])) {
                return null;
            }

            return (
                <Marker
                    key={cp.id}
                    position={{ lng: cp.geometry[0], lat: cp.geometry[1] }}
                    label={this.iconLabelCabinet}
                    icon={this.iconCabinet}
                />
            );
        }).filter(x => x );
        this.setState({ 'cabinets': plComponents })
    }

    render() {
        return (
            <div className="mapContainer">
                <GoogleMap
                    ref={this.handleMapMounted}
                    defaultCenter={this.props.mapCenter}
                    defaultZoom={this.props.mapCenter.zoom}
                    onIdle={this.getAndSetBounds}
                    options={{
                        gestureHandling: "greedy",
                        scrollwheel: true,
                        fullScreenControl: false,
                        mapTypeControl: false,
                        streetViewControl: false,
                        scaleControl: false,
                        clickableIcons: false,
                        disableDoubleClickZoom: true,
                        disableDefaultUI: true,
                        styles: __GMAP_STYLE
                    }}>
                    </GoogleMap>
                    {this.state.lightPoints}
                    {this.state.cabinets}
                <ViewFinderIcon style={viewFinderStyle} />
            </div>
        );
    }
};

export default withGoogleMap(Map);
